import cached_reactive from '@phi/cached-reactive';
import type { Store } from '@phi/util/store';
import type { Session} from '@phi/session';
import type { SubscriptionStatus } from '@phi/subscriptions';
import type { Option } from '@vaaas/fpts/option';

/** DeviceStorage contains settings that should be cached in the current user's device,
 * but they should not be synced to all devices via the server.
 *
 * Therefore, anything put into device storage is cleared when cookies and storage is cleared.
 */
export type DeviceStorage = typeof defaults;

export const defaults = {
    /** whether the user consents to being tracked by cookies */
    consents_to_cookies: undefined as true | false | undefined,

    /** timestamp of last time user consented to cookies */
    last_consented_to_cookies: undefined as undefined | number,

    /** stores the current authorization bearer token for the user */
    token: undefined as Option<Session['id']>,

    /** what kind of subscription this user has */
    user_subscription_status: undefined as Option<SubscriptionStatus>,

    user_trial_end: undefined as undefined | number,
};

export default (store: Store) => cached_reactive(
    store,
    'device-storage',
    {...defaults},
);
